import WrapperComponent from '../components/hoc/Wrapper-component';
import { Register } from './registration/registration-line/Register';
import { ProfileScene } from './profile/ProfileScene';
import { RegisterTelScene } from './registration/register-tel/RegisterTelScene';
import { HomeScene } from './home/HomeScene';
import { ClaimScene } from './claims/ClaimScene';
import { RegisterInfo } from './registration/registration-info/RegisterInfo';
import { TermWarranty } from './term/warranty/TermWarranty';
export default {
  Register: WrapperComponent('Register')(Register),
  HomeScene: WrapperComponent('HomeScene')(HomeScene),
  ProfileScene: WrapperComponent('ProfileScene')(ProfileScene),
  RegisterTelScene: WrapperComponent('RegisterTelScene')(RegisterTelScene),
  ClaimScene: WrapperComponent('ClaimScene')(ClaimScene),
  RegisterInfo: WrapperComponent('RegisterInfo')(RegisterInfo),
  TermWarranty: WrapperComponent('TermWarranty')(TermWarranty),
};
